import type { RouteRecordRaw } from 'vue-router';

export const lcaRouterList: RouteRecordRaw[] = [
    {
        path: 'lca/:agent_job_id',
        name: 'ai-ls-lca-detail',
        component: () => import('@/pages/ai-ls/AgentFlowResult.vue'),
        props: () => ({ isSharePage: false }),
        beforeEnter: (to) => {
            if (to.query.agent === 'lca') return true

            return {
                path: to.path,
                query: { ...to.query, agent: 'lca' },
                replace: true,
            }
        },
    },
    {
        path: 'lca/share/:agent_share_id',
        name: 'ai-ls-lca-share-redirect',
        component: () => import('@/pages/ai-ls/LcaShareRedirect.vue'),
    },
    {
        path: 'lca/share/result/:agent_job_id',
        name: 'ai-ls-lca-share-detail',
        component: () => import('@/pages/ai-ls/AgentFlowResult.vue'),
        props: () => ({ isSharePage: true }),
    }
]
